import { Helmet } from 'react-helmet';

import { config } from './config';

export const Script = () => {
  return (
    <>
      {config.gtag ? (
        <Helmet>
          <script>
            {`
            (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s),
                    dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', '${config.gtag}');
          `}
          </script>
        </Helmet>
      ) : null}
      {config.aw_gtag ? (
        <Helmet>
          <script async src={`https://www.googletagmanager.com/gtag/js?id=${config.aw_gtag}`} />
          <script>
            {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${config.aw_gtag}');
          `}
          </script>
        </Helmet>
      ) : null}
      {config.microsoftAds ? (
        <Helmet>
          <script>
            {`
            (function (w, d, t, r, u) {
                var f, n, i;
                w[u] = w[u] || [], f = function () {
                    var o = { ti: "${config.microsoftAds}", enableAutoSpaTracking: true };
                    o.q = w[u], w[u] = new UET(o), w[u].push("pageLoad")
                },
                n = d.createElement(t), n.src = r, n.async = 1, n.onload = n.onreadystatechange = function () {
                    var s = this.readyState;
                    s && s !== "loaded" && s !== "complete" || (f(), n.onload = n.onreadystatechange = null)
                },
                i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i)
            })
            (window, document, "script", "https://bat.bing.com/bat.js", "uetq");
          `}
          </script>
        </Helmet>
      ) : null}
    </>
  );
};
